var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",staticClass:"checkbox-settings-modal",attrs:{"close-button-label":_vm.$t("button.cancel"),"no-footer":true,"title":_vm.$t("modal.image_settings.title"),"size":"sm"},on:{"closed":_vm.onClose}},[(_vm.element)?_c('div',{staticClass:"col-12"},[_c('upload-area',{key:_vm.key,on:{"change":_vm.loadFile}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }